import { YouTube } from "$components";
import GoogleZoomImage from "../../../../content/articles/2019-12-29-google-maps-clustering/google-zoom.gif";
import React from 'react';
export default {
  YouTube,
  GoogleZoomImage,
  React
};